import io from "socket.io-client";
import { SOCKET_URL } from "../constants/constants";

export const socket = io(SOCKET_URL, {
  autoConnect: false,
  withCredentials: true,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 99999,
  transports: ["websocket"],
});
